import { render, staticRenderFns } from "./medicalRecordList.vue?vue&type=template&id=5b69617c&"
import script from "./medicalRecordList.vue?vue&type=script&lang=js&"
export * from "./medicalRecordList.vue?vue&type=script&lang=js&"
import style0 from "./medicalRecordList.vue?vue&type=style&index=0&id=5b69617c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports